document.addEventListener('DOMContentLoaded', function() {
  const password = document.querySelector('.input--password')
  const emailInput = document.querySelector('.input--email')
  const submitRegistration = document.querySelector('.custormer-registration-submit')
  const upperCheck = new RegExp("(?=.*[A-Z])")
  const numberCheck = new RegExp("(?=.*[0-9])")
  const lengthCheck = new RegExp("(?=.{6,})")
  const emailCheck = new RegExp('[A-Za-z0-9\._%+\-]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,}');
  let isPasswordValid, isEmailValid = false;

  password.addEventListener("focus", function(event) {
    validatePassword()
    isFormValid()
  });

  password.addEventListener("keyup", function(event) {
    validatePassword()
    isFormValid()
  });

  emailInput.addEventListener("focus", function(event) {
    validateEmail()
    isFormValid()
  });

  emailInput.addEventListener("keyup", function(event) {
    validateEmail()
    isFormValid()
  });

  submitRegistration.addEventListener("click", function(event) {
    if (!formIsValid()) {
      event.preventDefault()
    }
  });

  
  function validateEmail(email) {
    isEmailValid = emailCheck.test(emailInput.value);
    const emailValidation = document.querySelector('.email-validation');
    if (isEmailValid) {
      emailValidation.classList.remove('missing')
      emailValidation.classList.add('passed')
    } else {
      emailValidation.classList.remove('passed')
      emailValidation.classList.add('missing')
    }
    
  }
  
  function validatePassword() {
    const passwordValue = password.value;

    const upperCheckResult = upperCheck.test(passwordValue)
    const numberCheckResult = numberCheck.test(passwordValue)
    const lengthCheckResult = lengthCheck.test(passwordValue)
    const upperValidation = document.querySelector('.upper-validation');
    const numberValidation = document.querySelector('.number-validation');
    const lengthValidation = document.querySelector('.length-validation');

    if (upperCheckResult) {
      upperValidation.classList.remove('missing')
      upperValidation.classList.add('passed')
    } else {
      upperValidation.classList.remove('passed')
      upperValidation.classList.add('missing')
    }

    if (numberCheckResult) {
      numberValidation.classList.remove('missing')
      numberValidation.classList.add('passed')
    } else {
      numberValidation.classList.remove('passed')
      numberValidation.classList.add('missing')
    }

    if (lengthCheckResult) {
      lengthValidation.classList.remove('missing')
      lengthValidation.classList.add('passed')
    } else {
      lengthValidation.classList.remove('passed')
      lengthValidation.classList.add('missing')
    }

    isPasswordValid = upperCheckResult && numberCheckResult && lengthCheckResult;

    
  }

  function isFormValid() {
    isPasswordValid && isEmailValid ? submitRegistration.removeAttribute('disabled')
      : submitRegistration.setAttribute('disabled', true);
  }

  isFormValid();
});
